<div class="d-flex flex-column align-items-center px-3">

</div>
     <div class="bbc-news-grid container">
    <div 
      v-for="(report, index) in filtered_reports"
      :key="report.id"
      :class="['bbc-card', getCardSize(index)]"
    >
         <router-link :to="`/view_full_report/${report.id}/${$route.params.portal_id}/${$route.params.portal_name}`" class="text-decoration-none text-dark">
          <div class="card mb-4 shadow-sm border-0 rounded-5 h-100">
            <div v-for="(fileObj, index) in report.report_files" :key="index" >
                        <!-- Image -->
                        <img v-if="fileObj.file.file_url.includes('.jpg') ||
                                      fileObj.file.file_url.includes('.png') || 
                                      fileObj.file.file_url.includes('.jpeg')" :src="fileObj.file.file_url"
                          alt="Feed Image" class="img-fluid image-blog w-100"
                        />

                        <!-- Audio -->
                        <audio v-else-if="fileObj.file.file_url.includes('.mp3') ||
                                            fileObj.file.file_url.includes('.wav')" controls class="w-100">
                          <source :src="fileObj.file.file_url" type="audio/mp3">
                          Your browser does not support the audio element.
                        </audio>

                        <!-- Video -->
                        <video v-else-if="fileObj.file.file_url.includes('.mp4')" controls
                          class="img-fluid rounded-5 w-100" @click="display_comment_modal(report)">
                          <source :src="fileObj.file.file_url" type="video/mp4">
                          Your browser does not support the video tag.
                        </video>

                        <div v-else class="uploaded-file m-2" @click="display_comment_modal(report)">
                          <img :src="getFileIcon(fileObj.file.file_url)" class="file-icon small-icon" />
                          <span class="file-name">{{ getFileName(fileObj.file.file_url) }}</span>
                          <a :href="fileObj.file.file_url" download :title="getFileName(fileObj.file.file_url)"
                            class="download-btn" @click.stop>
                            <img src="https://cdn-icons-png.flaticon.com/128/724/724933.png" class="download-icon" />
                          </a>
                        </div>

                      </div>  
              <div class="card-body">
            <div class="d-flex justify-content-between align-items-center">
              <!-- {{$route.params.portal_name}} -->
                <p class="text-muted mb-1 text-xxs mb-0">
  {{
    report.tags.find(tag => tag.tag_category.name.toLowerCase() === 'years')
      ? `${report.tags.find(tag => tag.tag_category.name.toLowerCase() === 'years').name} (Year)`
      : report.publication_date
  }}
  &nbsp; | &nbsp;
  <router-link
  :to="`/view_full_report/${report.id}/${$route.params.portal_id}/${$route.params.portal_name}`"
  class="text-decoration-none text-dark"
>
  {{
    report.tags.find(tag => tag.tag_category.name.toLowerCase() === 'authors')?.name
      ? `${report.tags.find(tag => tag.tag_category.name.toLowerCase() === 'authors')?.name} (Author)`
      : report.creater?.first_name && report.creater?.last_name
        ? `${report.creater.first_name} ${report.creater.last_name}`
        : report.creater?.company_name
  }}
</router-link>

</p>



                <div class="dropdown">
                  <a href="#" class="fw-bold text-dark text-end" id="dropdownMenuButton" data-bs-toggle="dropdown"
                    aria-expanded="false">
                    <i class="bi bi-three-dots-vertical"></i>
                  </a>
                  <ul class="dropdown-menu custom-dropdown lh-1" aria-labelledby="dropdownMenuButton">
                    <li>
                      <a class="dropdown-item text-xs fw-bold" href="#"
                        @click.prevent="delete_report(report.id)">
                        <i class="bx bxs-trash-alt fs-6"></i> Delete
                      </a>
                    </li>
                     <li v-if="String(report.creater?.base_profile?.creater.id) === String(user_details.user_id) || String(report.creater.id) === String(user_details.user_id)">
                        <a class="dropdown-item text-xs fw-bold" href="" data-bs-toggle="modal"
                          data-bs-target="#edit_report_modal" @click="edit_report(report)"
                          >
                          <i class="bx bxs-edit fs-6"></i> Edit
                        </a>
                    </li>
                   
                  </ul>
                </div>
              </div>
              <div class="mt-2 mb-2">

  <span v-for="tag in get_filtered_tags(report.tags)" :key="tag.id" class="badge bg-primary me-1 text-capitalize">
    {{ tag.name }}
  </span>
</div>
                  <p class="card-text text-muted text-xs" v-html="get_description(report)"></p>

                  <a
                    v-if="report.description && report.description.length > 250"
                    href="#"
                    @click.prevent="toggle_description(report.id)"
                    class="text-secondary text-decoration-none fw-bold text-xs"
                  >
                    {{ expandedReports.includes(report.id) ? 'Read less' : 'Read more' }}
                  </a>
                  <div v-if="String(report.creater?.id) !== String(user_details.user_id) && user_details.user_role === 'admin' && report.status?.name === 'pending' " class="mt-3 d-flex gap-2 ">
  <button
    class="btn btn-sm btn-success rounded-pill px-3"
    @click.stop.prevent="approve_report(report.id)"
  >
    <i class="bi bi-check-circle me-1"></i> Approve
  </button>
  <button
    class="btn btn-sm btn-danger rounded-pill px-3"
    @click.stop.prevent="reject_report(report.id)"
  >
    <i class="bi bi-x-circle me-1"></i> Reject
  </button>
</div>
            </div>      

         </div>
      </router-link>
      </div>
    </div>